// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_file_qa.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.QAFileVersion
 */ export class QAFileVersion extends Message {
    static fromBinary(bytes, options) {
        return new QAFileVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAFileVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAFileVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAFileVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_id = 1;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string parent_version_id = 3;
   */ _define_property(this, "parentVersionId", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string filename = 5;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string mime_type = 6;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string sha256 = 7;
   */ _define_property(this, "sha256", ""), /**
   * @generated from field: string selected_by = 8;
   */ _define_property(this, "selectedBy", ""), /**
   * @generated from field: string selected_at = 9;
   */ _define_property(this, "selectedAt", ""), /**
   * @generated from field: bool current = 10;
   */ _define_property(this, "current", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAFileVersion, "runtime", proto3);
_define_property(QAFileVersion, "typeName", "mono.datagateway.v1.QAFileVersion");
_define_property(QAFileVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "selected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "selected_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QAFileCheck
 */ export class QAFileCheck extends Message {
    static fromBinary(bytes, options) {
        return new QAFileCheck().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAFileCheck().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAFileCheck().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAFileCheck, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string run_id = 2;
   */ _define_property(this, "runId", ""), /**
   * @generated from field: string instruction_id = 3;
   */ _define_property(this, "instructionId", ""), /**
   * @generated from field: string source_document_id = 4;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * Full extracted-fact snapshot, including source text, blocks, pages and attributes.
   *
   * @generated from field: string instruction_snapshot_json = 5;
   */ _define_property(this, "instructionSnapshotJson", ""), /**
   * @generated from field: string file_id = 6;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 7;
   */ _define_property(this, "versionId", ""), /**
   * pass | issue | not_checked. AI suggestions never produce pass.
   *
   * @generated from field: string result = 8;
   */ _define_property(this, "result", ""), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string evidence = 10;
   */ _define_property(this, "evidence", ""), /**
   * @generated from field: string checked_by = 11;
   */ _define_property(this, "checkedBy", ""), /**
   * @generated from field: string checked_at = 12;
   */ _define_property(this, "checkedAt", ""), /**
   * @generated from field: bool stale = 13;
   */ _define_property(this, "stale", false), /**
   * @generated from field: string stale_at = 14;
   */ _define_property(this, "staleAt", ""), /**
   * @generated from field: string stale_reason = 15;
   */ _define_property(this, "staleReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAFileCheck, "runtime", proto3);
_define_property(QAFileCheck, "typeName", "mono.datagateway.v1.QAFileCheck");
_define_property(QAFileCheck, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "instruction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "instruction_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "result",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "checked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "checked_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "stale_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "stale_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QAFileRun
 */ export class QAFileRun extends Message {
    static fromBinary(bytes, options) {
        return new QAFileRun().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAFileRun().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAFileRun().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAFileRun, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string file_id = 2;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string checked_by = 4;
   */ _define_property(this, "checkedBy", ""), /**
   * @generated from field: string checked_at = 5;
   */ _define_property(this, "checkedAt", ""), /**
   * @generated from field: bool stale = 6;
   */ _define_property(this, "stale", false), /**
   * @generated from field: string stale_at = 7;
   */ _define_property(this, "staleAt", ""), /**
   * @generated from field: string stale_reason = 8;
   */ _define_property(this, "staleReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAFileRun, "runtime", proto3);
_define_property(QAFileRun, "typeName", "mono.datagateway.v1.QAFileRun");
_define_property(QAFileRun, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "checked_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "checked_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "stale_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "stale_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QAHistory
 */ export class QAHistory extends Message {
    static fromBinary(bytes, options) {
        return new QAHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QAHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QAHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QAHistory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.QAFileVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.datagateway.v1.QAFileRun runs = 2;
   */ _define_property(this, "runs", []), /**
   * @generated from field: repeated mono.datagateway.v1.QAFileCheck checks = 3;
   */ _define_property(this, "checks", []), /**
   * @generated from field: string acceptance_disclaimer = 4;
   */ _define_property(this, "acceptanceDisclaimer", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QAHistory, "runtime", proto3);
_define_property(QAHistory, "typeName", "mono.datagateway.v1.QAHistory");
_define_property(QAHistory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: QAFileVersion,
            repeated: true
        },
        {
            no: 2,
            name: "runs",
            kind: "message",
            T: QAFileRun,
            repeated: true
        },
        {
            no: 3,
            name: "checks",
            kind: "message",
            T: QAFileCheck,
            repeated: true
        },
        {
            no: 4,
            name: "acceptance_disclaimer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectQAFileRequest
 */ export class SelectQAFileRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectQAFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectQAFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectQAFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectQAFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * Required to replace. Never infer identity from a name. CAS against current head.
   *
   * @generated from field: string replaces_version_id = 5;
   */ _define_property(this, "replacesVersionId", ""), /**
   * @generated from field: string sha256 = 6;
   */ _define_property(this, "sha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectQAFileRequest, "runtime", proto3);
_define_property(SelectQAFileRequest, "typeName", "mono.datagateway.v1.SelectQAFileRequest");
_define_property(SelectQAFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "replaces_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetQAHistoryRequest
 */ export class GetQAHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetQAHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQAHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQAHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQAHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * Empty filters return the project's complete QA history for the panel.
   *
   * @generated from field: string file_id = 3;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 4;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQAHistoryRequest, "runtime", proto3);
_define_property(GetQAHistoryRequest, "typeName", "mono.datagateway.v1.GetQAHistoryRequest");
_define_property(GetQAHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveQARunRequest
 */ export class SaveQARunRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveQARunRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveQARunRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveQARunRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveQARunRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string file_id = 4;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string version_id = 5;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.QAFileCheck checks = 6;
   */ _define_property(this, "checks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveQARunRequest, "runtime", proto3);
_define_property(SaveQARunRequest, "typeName", "mono.datagateway.v1.SaveQARunRequest");
_define_property(SaveQARunRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "checks",
            kind: "message",
            T: QAFileCheck,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectQAFileResponse
 */ export class SelectQAFileResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectQAFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectQAFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectQAFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectQAFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAFileVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectQAFileResponse, "runtime", proto3);
_define_property(SelectQAFileResponse, "typeName", "mono.datagateway.v1.SelectQAFileResponse");
_define_property(SelectQAFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: QAFileVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetQAHistoryResponse
 */ export class GetQAHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetQAHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQAHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQAHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQAHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQAHistoryResponse, "runtime", proto3);
_define_property(GetQAHistoryResponse, "typeName", "mono.datagateway.v1.GetQAHistoryResponse");
_define_property(GetQAHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: QAHistory
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveQARunResponse
 */ export class SaveQARunResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveQARunResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveQARunResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveQARunResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveQARunResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QAHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveQARunResponse, "runtime", proto3);
_define_property(SaveQARunResponse, "typeName", "mono.datagateway.v1.SaveQARunResponse");
_define_property(SaveQARunResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: QAHistory
        }
    ]));
